import { render, staticRenderFns } from "./OnhbSubscription.vue?vue&type=template&id=4fddfad0&scoped=true&"
import script from "./OnhbSubscription.vue?vue&type=script&lang=js&"
export * from "./OnhbSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fddfad0",
  null
  
)

export default component.exports